export default ["ar", "fa", "he"];
